module.exports = __webpack_public_path__ + "static/media/backpackbuddy-student-template.8694ef68.xlsx";